import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import SvgIcon from "@mui/material/SvgIcon";
import classnames from "classnames";
import { useStyles } from "./Reactions.styles.js";
const ThumbsDown = (t0)=>{
    const $ = c(56);
    const { size: t1, color: t2 } = t0;
    const size = void 0 === t1 ? "default" : t1;
    const color = void 0 === t2 ? "secondary" : t2;
    const { classes } = useStyles();
    const t3 = classes[`icon_size_${size}`];
    const t4 = classes[`icon_color_${color}`];
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = classnames(t3, t4);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M10.193 2.7449C6.74257 2.7449 4.95703 4.00545 4.47968 6.56287C3.91132 9.38904 5.94531 11.6179 6.74257 12.2969C7.58554 13.0144 8.37538 14.1453 8.29179 15.9527C8.18906 18.1777 10.5508 18.5 11.2668 16.4152C11.8715 14.6547 10.4777 12.4269 11.3531 11.4949C11.6666 11.195 12.5484 11.1014 12.5484 11.1014C12.9714 11.0409 13.7046 11.0292 13.9724 11.0212C15.7248 10.6463 14.428 9.57588 14.5043 8.63006C14.8691 7.43592 15.0538 2.7449 10.193 2.7449Z",
            fill: "url(#paint0_radial_4706_230592)"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            opacity: "0.7",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.7465 12.3002C7.58799 13.018 8.37525 14.1481 8.29179 15.9527C8.18906 18.1777 10.5508 18.5 11.2668 16.4152C11.56 15.5614 11.3833 14.5978 11.2233 13.7253C11.0549 12.8075 10.9051 11.9905 11.3405 11.5086C11.3449 11.5041 11.3492 11.4995 11.3535 11.4949C11.952 10.8575 12.0604 10.5982 12.0534 10.5043C12.1159 10.5169 12.2393 10.5191 12.468 10.4856C14.4561 10.1946 14.4661 9.81022 14.4864 9.03155C14.4896 8.90805 14.493 8.77463 14.5047 8.63008C14.8695 7.43594 15.1167 2.74493 10.1934 2.74493H10.193C6.74257 2.74493 4.95703 4.00548 4.47968 6.5629C3.91132 9.38907 5.94531 11.618 6.74257 12.2969C6.74388 12.298 6.74519 12.2991 6.7465 12.3002Z",
            fill: "url(#paint1_radial_4706_230592)"
        });
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t20;
    let t21;
    let t22;
    let t23;
    let t24;
    let t25;
    let t26;
    let t27;
    let t28;
    let t29;
    let t30;
    let t8;
    let t9;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter0_f_4706_230592)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M5.68164 7.01103C10.0695 6.74423 8.16758 3.23173 11.0359 3.73173C11.7742 3.86064 11.7922 9.54462 11.7723 10.6497C10.5047 10.9388 10.8328 10.0591 10.8328 10.0591C10.8328 10.0591 10.0152 7.15322 5.68164 7.01064V7.01103Z",
                fill: "url(#paint2_radial_4706_230592)"
            })
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M8.09454 4.62184C7.89376 3.55309 8.72384 2.77809 9.80782 2.86637C11.0754 2.9695 11.7637 2.82614 11.9645 3.89489C12.1652 4.96364 11.4617 5.99255 10.393 6.19333C9.32423 6.39411 8.29532 5.69059 8.09454 4.62184Z",
            fill: "url(#paint3_radial_4706_230592)"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M10.5638 5.44628C9.52983 5.34424 9.24897 3.58738 10.1951 3.20814C11.4603 2.7009 13.5431 2.64604 14.2986 3.1467C15.0541 3.64735 15.1935 4.90027 14.1958 5.25757C13.1978 5.61487 11.5978 5.54831 10.5638 5.44628Z",
            fill: "url(#paint4_radial_4706_230592)"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M10.5638 5.44628C9.52983 5.34424 9.24897 3.58738 10.1951 3.20814C11.4603 2.7009 13.5431 2.64604 14.2986 3.1467C15.0541 3.64735 15.1935 4.90027 14.1958 5.25757C13.1978 5.61487 11.5978 5.54831 10.5638 5.44628Z",
            fill: "url(#paint5_radial_4706_230592)"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M10.5638 5.44628C9.52983 5.34424 9.24897 3.58738 10.1951 3.20814C11.4603 2.7009 13.5431 2.64604 14.2986 3.1467C15.0541 3.64735 15.1935 4.90027 14.1958 5.25757C13.1978 5.61487 11.5978 5.54831 10.5638 5.44628Z",
            fill: "url(#paint6_radial_4706_230592)"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M10.5638 5.44628C9.52983 5.34424 9.24897 3.58738 10.1951 3.20814C11.4603 2.7009 13.5431 2.64604 14.2986 3.1467C15.0541 3.64735 15.1935 4.90027 14.1958 5.25757C13.1978 5.61487 11.5978 5.54831 10.5638 5.44628Z",
            fill: "url(#paint7_radial_4706_230592)"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M10.0293 4.07422C11.1166 4.07422 11.998 4.95566 11.998 6.04297C11.998 7.13028 11.1166 8.01172 10.0293 8.01172C8.94199 8.01172 8.06055 7.13028 8.06055 6.04297C8.06055 4.95566 8.94199 4.07422 10.0293 4.07422Z",
            fill: "url(#paint8_radial_4706_230592)"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M10.6336 7.11988C9.43397 7.0215 8.86796 5.06422 10.2098 4.67584C11.7148 4.23991 14.0969 4.0779 14.9715 4.576C15.8461 5.0741 16.009 6.55668 14.8492 6.91764C13.6894 7.27859 11.8332 7.21825 10.6336 7.11988Z",
            fill: "url(#paint9_radial_4706_230592)"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            d: "M10.6336 7.11988C9.43397 7.0215 8.86796 5.06422 10.2098 4.67584C11.7148 4.23991 14.0969 4.0779 14.9715 4.576C15.8461 5.0741 16.009 6.55668 14.8492 6.91764C13.6894 7.27859 11.8332 7.21825 10.6336 7.11988Z",
            fill: "url(#paint10_radial_4706_230592)"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M10.6336 7.11988C9.43397 7.0215 8.86796 5.06422 10.2098 4.67584C11.7148 4.23991 14.0969 4.0779 14.9715 4.576C15.8461 5.0741 16.009 6.55668 14.8492 6.91764C13.6894 7.27859 11.8332 7.21825 10.6336 7.11988Z",
            fill: "url(#paint11_radial_4706_230592)"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M10.6336 7.11988C9.43397 7.0215 8.86796 5.06422 10.2098 4.67584C11.7148 4.23991 14.0969 4.0779 14.9715 4.576C15.8461 5.0741 16.009 6.55668 14.8492 6.91764C13.6894 7.27859 11.8332 7.21825 10.6336 7.11988Z",
            fill: "url(#paint12_radial_4706_230592)"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M14.064 11.0252C13.8965 11.0252 11.8082 11.0124 11.3539 11.496C10.4785 12.428 11.8723 14.6558 11.2676 16.4163C10.5516 18.5011 8.18945 18.1784 8.29258 15.9538C8.37617 14.1464 7.58633 13.0155 6.74336 12.298C6.45273 12.0507 5.99766 11.5972 5.56445 10.9839C8.05234 9.12765 10.7563 9.41579 12.3016 10.3228L14.064 11.0252Z",
            fill: "url(#paint13_radial_4706_230592)"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            d: "M14.064 11.0252C13.8965 11.0252 11.8082 11.0124 11.3539 11.496C10.4785 12.428 11.8723 14.6558 11.2676 16.4163C10.5516 18.5011 8.18945 18.1784 8.29258 15.9538C8.37617 14.1464 7.58633 13.0155 6.74336 12.298C6.45273 12.0507 5.99766 11.5972 5.56445 10.9839C8.05234 9.12765 10.7563 9.41579 12.3016 10.3228L14.064 11.0252Z",
            fill: "url(#paint14_radial_4706_230592)",
            fillOpacity: "0.7"
        });
        t21 = /*#__PURE__*/ jsx("path", {
            d: "M14.064 11.0252C13.8965 11.0252 11.8082 11.0124 11.3539 11.496C10.4785 12.428 11.8723 14.6558 11.2676 16.4163C10.5516 18.5011 8.18945 18.1784 8.29258 15.9538C8.37617 14.1464 7.58633 13.0155 6.74336 12.298C6.45273 12.0507 5.99766 11.5972 5.56445 10.9839C8.05234 9.12765 10.7563 9.41579 12.3016 10.3228L14.064 11.0252Z",
            fill: "url(#paint15_radial_4706_230592)",
            fillOpacity: "0.4"
        });
        t22 = /*#__PURE__*/ jsx("path", {
            opacity: "0.7",
            d: "M14.064 11.0252C13.8965 11.0252 11.8082 11.0124 11.3539 11.496C10.4785 12.428 11.8723 14.6558 11.2676 16.4163C10.5516 18.5011 8.18945 18.1784 8.29258 15.9538C8.37617 14.1464 7.58633 13.0155 6.74336 12.298C6.45273 12.0507 5.99766 11.5972 5.56445 10.9839C8.05234 9.12765 10.7563 9.41579 12.3016 10.3228L14.064 11.0252Z",
            fill: "url(#paint16_radial_4706_230592)",
            fillOpacity: "0.8"
        });
        t23 = /*#__PURE__*/ jsx("path", {
            d: "M10.3672 7.69141C11.4545 7.69141 12.3359 8.57285 12.3359 9.66016C12.3359 10.7475 11.4545 11.6289 10.3672 11.6289C9.27988 11.6289 8.39844 10.7475 8.39844 9.66016C8.39844 8.57285 9.27988 7.69141 10.3672 7.69141Z",
            fill: "url(#paint17_radial_4706_230592)"
        });
        t24 = /*#__PURE__*/ jsx("path", {
            d: "M9.80762 5.94141C10.8949 5.94141 11.7764 6.82284 11.7764 7.91016C11.7764 8.99747 10.8949 9.87891 9.80762 9.87891C8.72031 9.87891 7.83887 8.99747 7.83887 7.91016C7.83887 6.82284 8.72031 5.94141 9.80762 5.94141Z",
            fill: "url(#paint18_radial_4706_230592)"
        });
        t25 = /*#__PURE__*/ jsx("path", {
            d: "M10.5502 9.00449C9.29473 8.87247 8.72832 7.05379 10.117 6.56045C11.8334 5.95081 14.558 5.93801 15.4553 6.43574C16.3525 6.93311 16.5182 8.4157 15.3283 8.77775C14.1385 9.1398 11.7775 9.13358 10.5502 9.00449Z",
            fill: "url(#paint19_radial_4706_230592)"
        });
        t26 = /*#__PURE__*/ jsx("path", {
            d: "M10.5502 9.00449C9.29473 8.87247 8.72832 7.05379 10.117 6.56045C11.8334 5.95081 14.558 5.93801 15.4553 6.43574C16.3525 6.93311 16.5182 8.4157 15.3283 8.77775C14.1385 9.1398 11.7775 9.13358 10.5502 9.00449Z",
            fill: "url(#paint20_radial_4706_230592)"
        });
        t27 = /*#__PURE__*/ jsx("path", {
            d: "M10.5502 9.00449C9.29473 8.87247 8.72832 7.05379 10.117 6.56045C11.8334 5.95081 14.558 5.93801 15.4553 6.43574C16.3525 6.93311 16.5182 8.4157 15.3283 8.77775C14.1385 9.1398 11.7775 9.13358 10.5502 9.00449Z",
            fill: "url(#paint21_radial_4706_230592)"
        });
        t28 = /*#__PURE__*/ jsx("path", {
            d: "M10.5502 9.00449C9.29473 8.87247 8.72832 7.05379 10.117 6.56045C11.8334 5.95081 14.558 5.93801 15.4553 6.43574C16.3525 6.93311 16.5182 8.4157 15.3283 8.77775C14.1385 9.1398 11.7775 9.13358 10.5502 9.00449Z",
            fill: "url(#paint22_radial_4706_230592)"
        });
        t29 = /*#__PURE__*/ jsx("path", {
            d: "M11.1526 10.7819C9.75139 10.6612 9.3401 9.14207 10.7273 8.63097C12.3968 8.01585 14.3499 8.27221 15.2582 8.64487C16.196 9.02959 16.324 10.6175 15.1643 10.9784C14.5241 11.1779 13.7546 10.9784 12.9349 10.9003C12.2144 10.8317 11.7536 10.8337 11.1526 10.7819Z",
            fill: "url(#paint23_radial_4706_230592)"
        });
        t30 = /*#__PURE__*/ jsx("path", {
            d: "M10.9786 10.7544C9.85384 10.66 9.31932 9.22049 10.7271 8.63083C12.3966 8.0157 14.3497 8.27207 15.2579 8.64472C16.1958 9.02945 16.3238 10.6266 15.164 10.9876C14.5477 11.1797 13.7977 11.0194 13.0124 10.9095C12.3228 10.8428 11.535 10.8414 10.9786 10.7544Z",
            fill: "url(#paint24_radial_4706_230592)"
        });
        $[5] = t10;
        $[6] = t11;
        $[7] = t12;
        $[8] = t13;
        $[9] = t14;
        $[10] = t15;
        $[11] = t16;
        $[12] = t17;
        $[13] = t18;
        $[14] = t19;
        $[15] = t20;
        $[16] = t21;
        $[17] = t22;
        $[18] = t23;
        $[19] = t24;
        $[20] = t25;
        $[21] = t26;
        $[22] = t27;
        $[23] = t28;
        $[24] = t29;
        $[25] = t30;
        $[26] = t8;
        $[27] = t9;
    } else {
        t10 = $[5];
        t11 = $[6];
        t12 = $[7];
        t13 = $[8];
        t14 = $[9];
        t15 = $[10];
        t16 = $[11];
        t17 = $[12];
        t18 = $[13];
        t19 = $[14];
        t20 = $[15];
        t21 = $[16];
        t22 = $[17];
        t23 = $[18];
        t24 = $[19];
        t25 = $[20];
        t26 = $[21];
        t27 = $[22];
        t28 = $[23];
        t29 = $[24];
        t30 = $[25];
        t8 = $[26];
        t9 = $[27];
    }
    let t31;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ jsxs("filter", {
            id: "filter0_f_4706_230592",
            x: "5.4082",
            y: "3.40918",
            width: "6.6416",
            height: "7.57227",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "0.136719",
                    result: "effect1_foregroundBlur_4706_230592"
                })
            ]
        });
        $[28] = t31;
    } else t31 = $[28];
    let t32;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint0_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.7215 16.4879) scale(14.3293)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFB100"
                })
            ]
        });
        $[29] = t32;
    } else t32 = $[29];
    let t33;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.4649 8.20397) rotate(160.304) scale(7.1343 10.8298)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.564882",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF8E00",
                    stopOpacity: "0.85"
                })
            ]
        });
        $[30] = t33;
    } else t33 = $[30];
    let t34;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.9823 6.92938) rotate(-178.409) scale(4.42237 5.48846)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.154202",
                    stopColor: "#C62400",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[31] = t34;
    } else t34 = $[31];
    let t35;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t35 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.1101 4.41877) rotate(12.8877) scale(1.80892)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#A80000"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[32] = t35;
    } else t35 = $[32];
    let t36;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint4_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.4441 4.2225) rotate(178.53) scale(3.60816 1.60209)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B700"
                })
            ]
        });
        $[33] = t36;
    } else t36 = $[33];
    let t37;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t37 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint5_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.8888 4.8314) rotate(-173.738) scale(3.79489 1.3501)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.369792",
                    stopColor: "#DA4E00",
                    stopOpacity: "0.5"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE918",
                    stopOpacity: "0"
                })
            ]
        });
        $[34] = t37;
    } else t37 = $[34];
    let t38;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t38 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint6_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.2216 4.72968) rotate(177.163) scale(3.30407 1.5915)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#F76D42"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B701",
                    stopOpacity: "0"
                })
            ]
        });
        $[35] = t38;
    } else t38 = $[35];
    let t39;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t39 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint7_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.6134 4.87943) scale(4.42617 4.14385)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.79",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.99",
                    stopColor: "#FF8E00",
                    stopOpacity: "0.4"
                })
            ]
        });
        $[36] = t39;
    } else t39 = $[36];
    let t40;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t40 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint8_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.0407 6.15328) rotate(-10.64) scale(2.08594)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#A80000"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[37] = t40;
    } else t40 = $[37];
    let t41;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t41 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint9_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(14.0107 5.88368) rotate(179.036) scale(4.46632 2.00717)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B700"
                })
            ]
        });
        $[38] = t41;
    } else t41 = $[38];
    let t42;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t42 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint10_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.1542 6.74934) rotate(-175.625) scale(4.2552 1.51385)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.44",
                    stopColor: "#DA4E00",
                    stopOpacity: "0.5"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE918",
                    stopOpacity: "0"
                })
            ]
        });
        $[39] = t42;
    } else t42 = $[39];
    let t43;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t43 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint11_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.0817 6.78215) rotate(-175.362) scale(3.29965 1.44617)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#F76D42"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B701",
                    stopOpacity: "0"
                })
            ]
        });
        $[40] = t43;
    } else t43 = $[40];
    let t44;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t44 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint12_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.2348 6.91874) scale(4.69687 4.39729)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.79",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.99",
                    stopColor: "#FF8E00",
                    stopOpacity: "0.4"
                })
            ]
        });
        $[41] = t44;
    } else t44 = $[41];
    let t45;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
        t45 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint13_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(1.10904 13.8536) rotate(-3.76058) scale(10.5241 17.2596)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.812811",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.959491",
                    stopColor: "#FF9C1F",
                    stopOpacity: "0.8"
                })
            ]
        });
        $[42] = t45;
    } else t45 = $[42];
    let t46;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t46 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint14_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.71248 14.1084) rotate(-11.5806) scale(2.55984 4.45677)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF8E00",
                    stopOpacity: "0.9"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[43] = t46;
    } else t46 = $[43];
    let t47;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t47 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint15_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(6.9725 12.6901) rotate(-40.4094) scale(1.99766 2.74871)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF8E00",
                    stopOpacity: "0.9"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[44] = t47;
    } else t47 = $[44];
    let t48;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t48 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint16_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.49311 11.3934) rotate(9.90436) scale(6.91024 9.84462)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.315291",
                    stopColor: "#FFC42E",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.846569",
                    stopColor: "#FF7DBE"
                })
            ]
        });
        $[45] = t48;
    } else t48 = $[45];
    let t49;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
        t49 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint17_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.5161 9.73268) rotate(-10.2996) scale(1.94367)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#BA4E00"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[46] = t49;
    } else t49 = $[46];
    let t50;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t50 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint18_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.8188 8.02045) rotate(-10.64) scale(2.08594)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#A81E00"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                })
            ]
        });
        $[47] = t50;
    } else t50 = $[47];
    let t51;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t51 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint19_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.9446 7.52191) rotate(177.687) scale(4.54194 2.31243)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B700"
                })
            ]
        });
        $[48] = t51;
    } else t51 = $[48];
    let t52;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t52 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint20_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.0145 8.95296) rotate(-172.737) scale(3.94235 1.6129)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.44",
                    stopColor: "#DA4E00",
                    stopOpacity: "0.5"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE918",
                    stopOpacity: "0"
                })
            ]
        });
        $[49] = t52;
    } else t52 = $[49];
    let t53;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t53 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint21_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.3224 8.66089) rotate(-175.673) scale(3.62978 1.48502)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#F76D42"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B701",
                    stopOpacity: "0"
                })
            ]
        });
        $[50] = t53;
    } else t53 = $[50];
    let t54;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
        t54 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint22_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(11.9475 8.9233) scale(4.56289 4.27185)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.79",
                    stopColor: "#FFD400",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.99",
                    stopColor: "#FF8E00",
                    stopOpacity: "0.4"
                })
            ]
        });
        $[51] = t54;
    } else t54 = $[51];
    let t55;
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t55 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint23_radial_4706_230592",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(14.5227 9.86673) rotate(178.53) scale(4.624 2.29462)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F7B700"
                })
            ]
        });
        $[52] = t55;
    } else t55 = $[52];
    let t56;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
        t56 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t31,
                t32,
                t33,
                t34,
                t35,
                t36,
                t37,
                t38,
                t39,
                t40,
                t41,
                t42,
                t43,
                t44,
                t45,
                t46,
                t47,
                t48,
                t49,
                t50,
                t51,
                t52,
                t53,
                t54,
                t55,
                /*#__PURE__*/ jsxs("radialGradient", {
                    id: "paint24_radial_4706_230592",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(11.2044 10.4842) scale(4.87656 4.56552)",
                    children: [
                        /*#__PURE__*/ jsx("stop", {
                            offset: "0.79",
                            stopColor: "#FFD400",
                            stopOpacity: "0"
                        }),
                        /*#__PURE__*/ jsx("stop", {
                            offset: "0.99",
                            stopColor: "#FF8E00",
                            stopOpacity: "0.4"
                        })
                    ]
                })
            ]
        });
        $[53] = t56;
    } else t56 = $[53];
    let t57;
    if ($[54] !== t5) {
        t57 = /*#__PURE__*/ jsxs(SvgIcon, {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: t5,
            children: [
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                t23,
                t24,
                t25,
                t26,
                t27,
                t28,
                t29,
                t30,
                t56
            ]
        });
        $[54] = t5;
        $[55] = t57;
    } else t57 = $[55];
    return t57;
};
export { ThumbsDown };
